const READY_STATES = ['ready', 'complete'];

// keep track of active modules
window.mountedModules = window.mountedModules || [];

/**
 * register module to be initialized
 * @param {String} name
 * @param {Class} ModuleClass
 */
export default function registerModule(name, ModuleClass) {
  /**
   * initialize module on matching elements
   */
  function initializeModule() {
    // get elements with data-js-module attribute matching module name
    const $moduleElements = document.querySelectorAll(`[data-js-module="${name}"]`);
    $moduleElements.forEach(($element) => {
      try {
        const module = new ModuleClass($element);
        module.initialize();
        window.mountedModules.push(module);
      } catch (error) {
        // Safari 15.0–15.3 lacks reportError; still report and isolate failures.
        // eslint-disable-next-line no-console
        (window.reportError || console.error)(error);
      }
    });
  }

  const isReady = READY_STATES.includes(document.readyState);
  if (isReady) {
    initializeModule();
  } else {
    document.addEventListener('DOMContentLoaded', initializeModule);
  }
}

// add to global namespace
window.registerModule = registerModule;
